import React from "react";

// import social media icons
import Facebook from "./images/001-facebook.png";
import LinkedIn from "./images/linkedin.png";
import Whatsapp from "./images/002-whatsapp.png";
import GitHub from "./images/003-github.png";

const Contact = () => {
    return <>
        <br/>
        <br/>
        <br />
        <br />
        <section id="contact" className="contact">
            <div className="my-3">
                <h2 className="g">Contact</h2>
                <p>Yo can contact me by any of these social media platforms, I am interested in new ideas and opportunities.</p>
            </div>
            <div>
                <a href="https://www.facebook.com/yahia.mahmood.33" target="_blank">
                    <img src={Facebook} alt="Facebook" loading="lazy" />
                </a>
                <a href="https://www.linkedin.com/in/yahia-mahmoud-82419621a/" target="_blank">
                    <img src={LinkedIn} alt="LinkedIn" loading="lazy" />
                </a>
                <a href="https://wa.me/201097741207" target="_blank">
                    <img src={Whatsapp} alt="Whatsapp" loading="lazy" />
                </a>
                <a href="https://github.com/yahia997" target="_blank">
                    <img src={GitHub} alt="GitHub" loading="lazy" />
                </a>
            </div>
        </section>
    </>
}

export default Contact;